import axios from 'axios'

axios.defaults.baseURL='https://apps.programage.com/InshutiManager/'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');